import { IonContent } from '@ionic/react';
import React from 'react';

import { GIRLS_CATEGORY, S3_BUCKET_URL, WOMEN_CATEGORY } from '@/constants';
import { useAccount } from '@/hooks/useAccount.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { getBotSlug } from '@/modules/botSlug.ts';
import { chatPinner } from '@/modules/chatPinner';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections.ts';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { useLayoutFormSelections } from '@/pages/Onboarding/Layouts/OwnAISecond/hooks/useLayoutFormSelections';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { ScreenAboutLookStyles } from './AboutLookFemale.styles';

export const ScreenAboutLook: React.FC = () => {
  const { user } = useAccount();
  const { ageGeneration, bodyShape, hairColor } = useLayoutSelections();
  const { age } = useLayoutFormSelections();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    const categoriesToPin = age === '50_plus' ? WOMEN_CATEGORY : GIRLS_CATEGORY;

    userService.createOrUpdate({
      categories: [categoriesToPin],
      onboarding_data: {
        first_categories: categoriesToPin,
      },
    });

    const slug = getBotSlug({
      ageGeneration,
      hairColor,
      bodyShape,
      gender: 'female',
    });
    if (user && slug) {
      chatPinner.pin(slug, user.id);
    }

    wizard.nextStep();
  };

  const getBgImage = () => {
    return `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`;
  };

  return (
    <ScreenAboutLookStyles bgImage={<img src={getBgImage()} alt="Chat Vibe" />}>
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You’ve nailed the appearance—seriously, great choice! Now, let’s dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
